import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faFaceSmile, faClock, faEarthAmericas } from "@fortawesome/free-solid-svg-icons";

import "../../styles/app/MetricsSection.css";

const metrics = [
  { icon: faBoxOpen, title: "+2M", desc: "Paquetes Entregados" },
  { icon: faFaceSmile, title: "99.8%", desc: "Satisfacción" },
  { icon: faClock, title: "5 Días", desc: "Tiempo Promedio" },
  { icon: faEarthAmericas, title: "5", desc: "Países Destino" },
];

const MetricsSection: React.FC = () => {
  const scrollToPickup = () => {
    const element = document.getElementById("pickup");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="metrics-section">
      <div className="metrics-container">
        <div className="metrics-text">
          <h2>El Courier Confiable para Latinoamérica</h2>
          <p>
            Únete a los miles de clientes que envían cajas, encomiendas y carga
            <br />a Venezuela, República Dominicana, Costa Rica, Guatemala y Perú
          </p>
          <button className="metrics-cta" onClick={scrollToPickup}>
            Empezar ahora
          </button>
        </div>
        <div className="metrics-grid">
          {metrics.map((m, i) => (
            <div className="metric-card" key={i}>
              <FontAwesomeIcon icon={m.icon} className="metric-icon" />
              <span className="metric-value">{m.title}</span>
              <span className="metric-label">{m.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;
